import { render, staticRenderFns } from "./YbtPayOrderResponse.vue?vue&type=template&id=2d0cb208&scoped=true"
import script from "./YbtPayOrderResponse.vue?vue&type=script&lang=js"
export * from "./YbtPayOrderResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0cb208",
  null
  
)

export default component.exports